<template>
  <v-card outlined class="card-center pb-2">
    <v-container class="px-4 py-4" fluid>
      <v-card flat>
        <v-card-title class="py-0">
          {{ $t('ELE0028') }}
        </v-card-title>
        <v-row dense class="mb-1">
          <v-col cols="4">
            <ManufacturerInput v-model="searchCondition.manufacturerCd" />
          </v-col>
          <v-col cols="4">
            <AcceptCompanyInput v-model="searchCondition.acceptCompanyCd" />
          </v-col>
          <v-col>
            <TextFieldInputWithDatePicker v-model="searchCondition.acceptDateFrom" :label="$t('ELE0201')" />
          </v-col>
          <span class="d-flex flex-row space-between mx-4 mt-3">
            {{ $t('ELE0141') }}
          </span>
          <v-col>
            <TextFieldInputWithDatePicker v-model="searchCondition.acceptDateTo" :label="$t('ELE0201')" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <TextFieldInput v-model="searchCondition.inspIndexNo" :label="$t('ELE0137')" />
          </v-col>
          <v-col cols="2">
            <TextFieldInput v-model="searchCondition.lotNo" :label="$t('ELE0049')" />
          </v-col>
          <v-col cols="2">
            <TextFieldInput v-model="searchCondition.partCd" :label="$t('ELE0031')" />
          </v-col>
          <v-col cols="2">
            <TextFieldInput v-model="searchCondition.model" :label="$t('ELE0224')" />
          </v-col>
          <v-col cols="2">
            <InspCat1MultipleInput v-model="searchCondition.oqcInspCat1" :label="$t('ELE0511')" />
          </v-col>
          <v-col cols="2">
            <InspCat2MultipleInput v-model="searchCondition.oqcInspCat2" :label="$t('ELE0512')" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <SelectMultipleInput
              v-model="searchCondition.inspStatus"
              :items="inspStatusItems"
              item-text="inspStatusText"
              item-value="inspStatusCd"
              :label="$t('ELE0139')"
            />
          </v-col>
          <v-col cols="2">
            <InspFilteringMultipleInput v-model="searchCondition.inspFiltering" />
          </v-col>
          <v-col cols="2">
            <SelectSingleInput
              v-model="searchCondition.xrfInspJudge"
              :items="xrfInspJudgeItems"
              item-text="xrfInspJudgeText"
              item-value="xrfInspJudgeCd"
              :label="$t('ELE0147')"
            />
          </v-col>
          <v-spacer />
          <v-col class="d-flex justify-end">
            <Btn
              class="mr-4"
              :label="$t('ELE0040') + ' ' + $t('ELE0056')"
              icon="mdi-download"
              @click="onClickDownloadRef"
            />
            <Btn class="mr-4" :label="$t('ELE0040')" icon="mdi-download" @click="onClickDownload" />
            <BtnSearch @click="onClickSearch" />
          </v-col>
        </v-row>
      </v-card>
      <v-card outlined>
        <v-card-title>
          {{ $t('ELE0023') }}
        </v-card-title>
        <v-data-table :headers="headers" :items="items" fixed-header :height="tableHeight" dense>
          <template v-slot:item.inspStatus="{ item }">
            <span v-if="item.inspStatus != ''">{{ $t('InspIndex.InspStatusCd.' + item.inspStatus) }} </span>
          </template>
          <template v-slot:item.appInspResultCd="{ item }">
            {{ getEnumlang('InspResultCd.', item.appInspResultCd) }}
          </template>
          <template v-slot:item.dimInspResultCd="{ item }">
            {{ showInspResultName('InspResultCd.', item.dimInspResultCd, item.isOutCl) }}
          </template>
          <template v-slot:item.xrfInspection="{ item }">
            <td
              v-if="item.xrfInspection != ''"
              class="v-data-table__divider"
              :style="{ 'background-color': item.xrfInspection == enumXrfInspNeedCd.NEED ? '#F8CED2' : '#BBD9F3' }"
            >
              {{ $t('XrfInspNeedCd.' + item.xrfInspection) }}
            </td>
            <td v-else class="v-data-table__divider"></td>
          </template>
          <template v-slot:item.action="{ item }">
            <IconInquiry @click="onClickInspSub(item)" />
          </template>
          <template v-slot:item.inspPoint="{ item }">
            <BtnLink :label="$t('ELE0162')" @click="onClickView(item.partCd)" />
          </template>
          <template v-slot:item.lotNo="{ item }">
            <BtnLink :label="item.lotNo" @click="onClickLotNo(item)" />
          </template>
          <!--項目名の先頭単語が短いため、v-datatable標準のalign:rightで右寄せすると、ヘッダーの先頭にソーターが付く-->
          <template v-slot:item.acceptBoxQty="{ item }">
            <td class="text-right v-data-table__divider">{{ item.acceptBoxQty }}</td>
          </template>
          <template v-slot:item.inspBoxQty="{ item }">
            <td class="text-right v-data-table__divider">{{ item.inspBoxQty }}</td>
          </template>
          <template v-slot:item.iqcInspResultCd="{ item }">
            <td class="v-data-table__divider" :style="{ 'background-color': getColorInspResult(item.iqcInspResultCd) }">
              {{ showInspResultName('InspResultCd.', item.iqcInspResultCd, item.iqcIsOutCl) }}
            </td>
          </template>
          <template v-slot:[`item.isSrcInsp`]="{ item }">
            {{ getEnumlang('isSrcInsp.', item.isSrcInsp.toString()) }}
          </template>
          <template v-slot:[`item.srcInspResultCd`]="{ item }">
            <td 
              class="v-data-table__divider"
              :style="{ 'background-color': getColorInspResult(item.srcInspResultCd) }"
              >
              {{ getEnumlang('InspResultCd.', item.srcInspResultCd) }}
            </td>
          </template>
          <template v-slot:item.oqcInspResultCd="{ item }">
            <td class="v-data-table__divider" :style="{ 'background-color': getColorInspResult(item.oqcInspResultCd) }">
              {{ showInspResultName('InspResultCd.', item.oqcInspResultCd, item.oqcIsOutCl) }}
            </td>
          </template>
        </v-data-table>
      </v-card>
      <SearchInspLotSubDialog
        v-if="selectedSubItems !== null"
        :dialog.sync="subDialog"
        :inspIndexNo="selectedSubItems.inspIndexNo"
        :manufacturerCompanyName="selectedSubItems.manufacturerCompanyName"
        :inspCompanyName="selectedSubItems.inspCompanyName"
        :acceptDatetime="selectedSubItems.acceptDatetime"
        :lotDate="selectedSubItems.lotDate"
        :lotNo="selectedSubItems.lotNo"
        :partCd="selectedSubItems.partCd"
        :inspStatusCd="selectedSubItems.inspStatusCd"
        @close="onClickSearch"
      />
      <SearchInspLotDtlDialog
        v-if="selectedDtlItems !== null"
        :dialog.sync="dtlDialog"
        :manufacturerCd="selectedDtlItems.manufacturerCd"
        :manufacturerCompanyName="selectedDtlItems.manufacturerCompanyName"
        :lotNo="selectedDtlItems.lotNo"
        :partCd="selectedDtlItems.partCd"
        :acceptCompanyCd="selectedDtlItems.acceptCompanyCd"
        :inspIndexNo="selectedDtlItems.inspIndexNo"
      />
      <v-dialog v-if="inspAttachDialog" v-model="inspAttachDialog" scrollable>
        <v-card>
          <v-card-title class="primary white--text py-2">
            {{ $t('ELE0191') }}
            <v-spacer />
            <Btn icon="mdi-close" @click="onClickViewClose" depressed iconProp color="white" />
          </v-card-title>
          <v-card-text>
            <InspAttachmentForm :partCd="selectedInspAttachItem.partCd" isInquiry />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-card>
</template>

<script>
import moment from 'moment'
import { InspStatusCd, XrfInspNeedCd, InspResultCd } from '@/enum'
import { ValidationObserver } from 'vee-validate'
import { API } from '@/plugins/api'
import { Storage } from '@/plugins/storage.js'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import StringUtils from '@/mixin/string-utils.js'

import Btn from '@/components/atoms/base/button/Btn'
import BtnDelete from '@/components/atoms/button/BtnDelete'
import BtnSave from '@/components/atoms/button/BtnSave'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import BtnNew from '@/components/atoms/button/BtnNew'
import BtnLink from '@/components/atoms/base/button/BtnLink'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker'
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import SelectMultipleInput from '@/components/atoms/base/select/SelectMultipleInput'
import IconInquiry from '@/components/atoms/icon/IconInquiry'

import SearchInspLotSubDialog from '@/components/organisms/terminal/dialog/SearchInspLotSubDialog'
import SearchInspLotDtlDialog from '@/components/organisms/terminal/dialog/SearchInspLotDtlDialog'
import InspAttachmentForm from '@/components/organisms/master/form/InspAttachmentForm'

import ManufacturerInput from '@/components/atoms/select/ManufacturerInput'
import AcceptCompanyInput from '@/components/atoms/select/AcceptCompanyInput'
import InspFilteringMultipleInput from '@/components/atoms/select/InspFilteringMultipleInput'
import InspCat1MultipleInput from '@/components/atoms/select/InspCat1MultipleInput'
import InspCat2MultipleInput from '@/components/atoms/select/InspCat2MultipleInput'

export default {
  name: 'SearchInspLotForm',

  mixins: [APIUtils, Message, Loading, DateUtils, StringUtils],

  components: {
    ValidationObserver,
    Btn,
    BtnDelete,
    BtnSave,
    BtnSearch,
    BtnNew,
    BtnLink,
    TextFieldInput,
    TextFieldInputWithDatePicker,
    SelectSingleInput,
    SelectMultipleInput,
    IconInquiry,
    SearchInspLotSubDialog,
    SearchInspLotDtlDialog,
    InspAttachmentForm,
    ManufacturerInput,
    AcceptCompanyInput,
    InspFilteringMultipleInput,
    InspCat1MultipleInput,
    InspCat2MultipleInput,
  },

  props: {
    propsInspIndexNo: {
      type: String,
      default: '',
      required: false,
    },
    propsAcceptDateFrom: {
      type: String,
      default: '',
      required: false,
    },
  },

  computed: {
    enumXrfInspNeedCd: () => XrfInspNeedCd,
    tableHeight: {
      get() {
        let height = this.$vuetify.breakpoint.height * 0.5
        if (height < 360) {
          height = 360
        }
        return `${height}px`
      },
    },
  },

  data() {
    return {
      subDialog: false,
      dtlDialog: false,
      inspAttachDialog: false,
      selectedSubItems: null,
      selectedDtlItems: null,
      selectedInspAttachItem: null,
      inspStatusItems: [],
      xrfInspJudgeItems: [],
      items: [],
      headers: [
        { text: this.$t('ELE0307'), value: 'action', divider: true, sortable: false },
        { text: this.$t('ELE0139'), value: 'inspStatus', divider: true },
        { text: this.$t('ELE0351'), value: 'iqcInspResultCd', divider: true },
        { text: this.$t('ELE0258'), value: 'appInspResultCd', divider: true },
        { text: this.$t('ELE0259'), value: 'dimInspResultCd', divider: true },
        { text: this.$t('ELE0143'), value: 'inspFiltering', divider: true },
        { text: this.$t('ELE0115'), value: 'inspTimingName', divider: true },
        { text: this.$t('ELE0148'), value: 'xrfInspection', divider: true },
        { text: this.$t('ELE0149'), value: 'xrfDate', divider: true },
        { text: this.$t('ELE0055'), value: 'acceptDatetime', divider: true },
        { text: this.$t('ELE0210'), value: 'inspEndDatetime', divider: true },
        { text: this.$t('ELE0134'), value: 'manufacturerCompanyName', divider: true },
        { text: this.$t('ELE0005'), value: 'acceptanceCompanyName', divider: true },
        { text: this.$t('ELE0049'), value: 'lotNo', divider: true },
        { text: this.$t('ELE0031'), value: 'partCd', divider: true },
        { text: this.$t('ELE0224'), value: 'model', divider: true },
        { text: this.$t('ELE0287'), value: 'partCatName', divider: true },
        { text: this.$t('ELE0150'), value: 'acceptBoxQty', divider: true },
        { text: this.$t('ELE0151'), value: 'inspBoxQty', divider: true },
        { text: this.$t('ELE0034'), value: 'inspPoint', divider: true },
        { text: this.$t('ELE0160'), value: 'iqcInspIndexNo', divider: true },
        { text: this.$t('ELE0161'), value: 'oqcInspIndexNo', divider: true },
        { text: this.$t('ELE0511'), value: 'oqcInspCat1Name', divider: true },
        { text: this.$t('ELE0512'), value: 'oqcInspCat2Name', divider: true },
        { text: this.$t('ELE0502'), value: 'isSrcInsp', divider: true },
        { text: this.$t('ELE0503'), value: 'srcInspResultCd', divider: true },
        { text: this.$t('ELE0350'), value: 'oqcInspResultCd' },
      ],
      searchCondition: {
        manufacturerCd: '',
        acceptCompanyCd: this.$store.getters.companyCd,
        acceptDateFrom: moment().format('YYYY-MM-DD'),
        acceptDateTo: moment().format('YYYY-MM-DD'),
        inspIndexNo: '',
        lotNo: '',
        partCd: '',
        model: '',
        xrfInspJudge: '',
        inspStatus: [InspStatusCd.WAITING_FOR, InspStatusCd.IN_PROGRESS],
        inspFiltering: [],
        oqcInspCat1: [],
        oqcInspCat2: [],
      },
    }
  },

  methods: {
    async onClickDownloadRef() {
      try {
        this.startLoading()
        const params = {
          userCompanyCd: this.$store.getters.companyCd,
          manufacturerCd: this.searchCondition.manufacturerCd,
          acceptCompanyCd: this.searchCondition.acceptCompanyCd,
          acceptDateFrom: this.searchCondition.acceptDateFrom,
          acceptDateTo: this.searchCondition.acceptDateTo,
          inspIndexNo: this.searchCondition.inspIndexNo,
          lotNo: this.searchCondition.lotNo,
          partCd: this.searchCondition.partCd,
          model: this.searchCondition.model,
          xrfInspJudge: this.searchCondition.xrfInspJudge,
          inspStatus: this.searchCondition.inspStatus,
          inspFiltering: this.searchCondition.inspFiltering,
          oqcInspCat1: this.searchCondition.oqcInspCat1,
          oqcInspCat2: this.searchCondition.oqcInspCat2,
        }
        const filePath = await API.get('/box/inspLots/file/ref', params)
        Storage.downloadFile(filePath)
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0078') })))
      } finally {
        this.stopLoading()
      }
    },
    async onClickDownload() {
      try {
        this.startLoading()
        const params = {
          userCompanyCd: this.$store.getters.companyCd,
          manufacturerCd: this.searchCondition.manufacturerCd,
          acceptCompanyCd: this.searchCondition.acceptCompanyCd,
          acceptDateFrom: this.searchCondition.acceptDateFrom,
          acceptDateTo: this.searchCondition.acceptDateTo,
          inspIndexNo: this.searchCondition.inspIndexNo,
          lotNo: this.searchCondition.lotNo,
          partCd: this.searchCondition.partCd,
          model: this.searchCondition.model,
          xrfInspJudge: this.searchCondition.xrfInspJudge,
          inspStatus: this.searchCondition.inspStatus,
          inspFiltering: this.searchCondition.inspFiltering,
          oqcInspCat1: this.searchCondition.oqcInspCat1,
          oqcInspCat2: this.searchCondition.oqcInspCat2,
        }
        const filePath = await API.get('/box/inspLots/file', params)
        Storage.downloadFile(filePath)
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0078') })))
      } finally {
        this.stopLoading()
      }
    },
    initInspStatusItems() {
      Object.keys(InspStatusCd).forEach((inspStatus) => {
        const item = {
          inspStatusCd: InspStatusCd[inspStatus],
          inspStatusText: this.$t('InspIndex.InspStatusCd.' + InspStatusCd[inspStatus]),
        }
        this.inspStatusItems.push(item)
      })
    },
    initXrfInspJdgeItems() {
      Object.keys(XrfInspNeedCd).forEach((xrfInspNeedCd) => {
        const item = {
          xrfInspJudgeCd: XrfInspNeedCd[xrfInspNeedCd],
          xrfInspJudgeText: this.$t('XrfInspNeedCd.' + XrfInspNeedCd[xrfInspNeedCd]),
        }
        this.xrfInspJudgeItems.push(item)
      })
    },
    getEnumlang(key, value) {
      // langのenumからメッセージ取得
      let lang = ''
      if (value) {
        lang = this.$t(key + value)
      }
      return lang
    },
    showInspResultName(key, value, isOutCl) {
      return this.getInspResultName(key, value, isOutCl)
    },
    getColorInspResult(inspResultCd) {
      // 検査結果に対応する色設定
      let color = ''

      if (inspResultCd == InspResultCd.OK) {
        color = '#EDEFFD'
      } else if (inspResultCd == InspResultCd.SA_OK) {
        color = '#FCF4A1'
      } else if (inspResultCd == InspResultCd.NG) {
        color = '#F8CED2'
      }

      return color
    },
    async onClickSearch() {
      this.startLoading()
      try {
        const params = {
          userCompanyCd: this.$store.getters.companyCd,
          manufacturerCd: this.searchCondition.manufacturerCd,
          acceptCompanyCd: this.searchCondition.acceptCompanyCd,
          acceptDateFrom: this.searchCondition.acceptDateFrom,
          acceptDateTo: this.searchCondition.acceptDateTo,
          inspIndexNo: this.searchCondition.inspIndexNo,
          lotNo: this.searchCondition.lotNo,
          partCd: this.searchCondition.partCd,
          model: this.searchCondition.model,
          xrfInspJudge: this.searchCondition.xrfInspJudge,
          inspStatus: this.searchCondition.inspStatus,
          inspFiltering: this.searchCondition.inspFiltering,
          oqcInspCat1: this.searchCondition.oqcInspCat1,
          oqcInspCat2: this.searchCondition.oqcInspCat2,
        }
        this.items = []
        const elements = await API.get('/box/inspLots', params)
        elements.forEach((element) => {
          element['acceptDatetime'] = this.toLocalTime(element['acceptDatetime'])
          element['inspEndDatetime'] = this.toLocalTime(element['inspEndDatetime'])
          element['lotDate'] = this.toLocalDate(element['lotDate'])
          if (element['xrfDate']) {
            element['xrfDate'] = this.toLocalDate(element['xrfDate'])
          }
          this.items.push(element)
        })
      } catch (error) {
        this.items = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0078') })))
      } finally {
        this.stopLoading()
      }
    },

    onClickInspSub(item) {
      this.selectedSubItems = {
        inspIndexNo: item.iqcInspIndexNo,
        manufacturerCompanyName: item.manufacturerCompanyName,
        inspCompanyName: item.inspCompanyName,
        acceptDatetime: item.acceptDatetime,
        lotDate: item.lotDate,
        lotNo: item.lotNo,
        partCd: item.partCd,
        inspStatusCd: item.inspStatus,
      }
      this.subDialog = true
    },
    onClickLotNo(item) {
      this.selectedDtlItems = {
        manufacturerCd: item.manufacturerCd,
        manufacturerCompanyName: item.manufacturerCompanyName,
        lotNo: item.lotNo,
        partCd: item.partCd,
        acceptCompanyCd: item.acceptanceCompanyCd,
        inspIndexNo: item.iqcInspIndexNo,
      }
      this.dtlDialog = true
    },
    onClickView(partCd) {
      this.selectedInspAttachItem = {
        partCd: partCd,
      }
      this.inspAttachDialog = true
    },
    onClickViewClose() {
      this.inspAttachDialog = false
    },
  },

  mounted() {
    this.initInspStatusItems()
    this.initXrfInspJdgeItems()
    if (this.propsInspIndexNo && this.propsAcceptDateFrom) {
      this.searchCondition.inspIndexNo = this.propsInspIndexNo
      this.searchCondition.acceptDateFrom = this.propsAcceptDateFrom
    }
  },
}
</script>
